import _Object$assign from 'babel-runtime/core-js/object/assign';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
// import DownloadButton from '@/components/DownloadButton/index.vue'
import ExportXlsx from '@/components/ExportXlsxBtn/index.vue';
import { interactiveChannelList } from '@com/utils/channel';
import { getCustomList as _getCustomList } from '@/api/creative/custom-dist.js';
import { format } from 'date-fns';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { orientation } from '@/common/material-metadata.js';
import { platform } from '@/common/platform';
import PreviewModal from '@/components/PreviewModal/index.vue';

export default {
  mixins: [searchMixin],

  components: {
    Search: Search,
    TableList: TableList,
    Pagination: Pagination,
    // DownloadButton,
    ExportXlsx: ExportXlsx,
    PreviewModal: PreviewModal
  },

  props: {},

  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15,
        platforms: [],
        search_field: 'mid',
        status: '',
        channel_ids: [],
        languages: [],
        order: '-created_time',
        keyword: ''
      },

      list: [],
      listLoading: false,

      tableConfig: {
        'row-key': 'id'
      },

      pagination: {
        total: 0
      },

      sheetTitle: '动态参数版本制作列表',
      sheetBody: [],
      previewDialog: {
        visible: false,
        title: '',
        html_url: '',
        showCnUrl: false,
        orientation: '',
        id: ''
      }
    };
  },


  computed: {
    formItemList: function formItemList() {
      var list = [{
        prop: 'search_field',
        type: 'select',
        params: {
          clearable: true,
          placeholder: '请选择搜索条件',
          style: 'width: 220px;',
          options: [{
            value: 'mid',
            label: 'Mid'
          }, {
            value: 'template_id',
            label: '创意方向ID'
          }, {
            value: 'template_name',
            label: '创意方向名称'
          }, {
            value: 'adv_name',
            label: '广告主名称'
          }, {
            value: 'package_name',
            label: '包名'
          }]
        }
      }, {
        prop: 'keyword',
        type: 'input',
        params: {
          style: 'width: 220px;',
          clearable: true,
          placeholder: '\u8BF7\u8F93\u5165' + this.query.search_field
        }
      }, {
        prop: 'languages',
        type: 'business',
        subtype: 'language-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          collapseTags: true,
          filterable: true,
          class: 'search-filter-select'
        }
      }, {
        prop: 'channel_ids',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: true,
          multiple: true,
          filterable: true,
          collapseTags: true,
          placeholder: '请选择投放渠道',
          options: interactiveChannelList,
          class: 'search-filter-select'
        }
      }, {
        prop: 'platforms',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: true,
          multiple: true,
          placeholder: '请选择投放平台',
          collapseTags: true,
          options: platform
        }
      }, {
        prop: 'status',
        type: 'select',
        params: {
          clearable: true,
          placeholder: '请选择状态',
          style: 'width: 220px;',
          collapseTags: true,
          options: [{
            value: 'Active',
            label: 'Active'
          }, {
            value: 'Deleted',
            label: 'Deleted'
          }]
        }
      }];

      return list;
    },
    tableColumnConfig: function tableColumnConfig() {
      var h = this.$createElement;

      return [{
        label: '序号',
        prop: 'id',
        width: 60
      }, {
        label: '包名',
        prop: 'package_name',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            if (row.package_name) return row.package_name;
            return '-';
          }
        }
      }, {
        label: '广告主名称',
        prop: 'adv_name',
        params: {
          innerText: function innerText(_ref2) {
            var row = _ref2.row;

            if (row.adv_name) return row.adv_name;
            return '-';
          }
        }
      }, {
        label: '创意方向名称',
        prop: 'template_name'
      }, {
        label: '版本名称',
        prop: 'custom_name'
      }, {
        label: '版本描述',
        prop: 'description'
      }, {
        label: '语言',
        prop: 'language',
        width: 80
      }, {
        label: '渠道',
        prop: 'channel',
        width: 80
      }, {
        label: '平台',
        prop: 'platform',
        width: 80
      }, {
        label: '横竖屏',
        prop: 'orientation',
        width: 60
      }, {
        label: 'Mid',
        prop: 'mid'
      }, {
        label: '版本创建时间',
        prop: 'created_time',
        sortable: 'custom'
      }, {
        label: '状态',
        prop: 'status',
        width: 80,
        renderHeader: function renderHeader() {
          var h = this.$createElement;

          return h(
            'span',
            null,
            [h(
              'el-tooltip',
              {
                attrs: { placement: 'top', effect: 'light' }
              },
              [h(
                'div',
                { slot: 'content' },
                [h(
                  'p',
                  null,
                  ['Active\u4EE3\u8868\u521B\u5EFA\u4E14\u672A\u88AB\u5220\u9664\u7684\u7248\u672C']
                ), h(
                  'p',
                  null,
                  ['Delete\u4EE3\u8868\u5220\u9664\u7684\u7248\u672C']
                )]
              ), h(
                'span',
                null,
                [h(
                  'i',
                  { 'class': 'el-icon-info' },
                  []
                ), ' \u72B6\u6001']
              )]
            )]
          );
        }
      }, {
        slot: 'action-cell'
      }];
    },
    sheetHeader: function sheetHeader() {
      var headers = {};
      this.tableColumnConfig.forEach(function (item) {
        if (item.prop) headers[item.prop] = item.label;
      });
      headers.html_url = '预览链接';
      return _extends({}, headers);
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.getCustomList();
    }
  },

  mounted: function mounted() {
    this.getCustomList();
  },


  methods: {
    cookSheetList: function cookSheetList(res) {
      var list = _.get(res, 'data.data.list') || [];
      return this.cookList(list);
    },
    cookList: function cookList(list) {
      return list.map(function (item) {
        return _extends({}, item, {
          orientation: useValueExchangeLabel(item.orientation, orientation),
          created_time: format(item.created_time * 1000, 'YYYY-MM-DD HH:mm:ss'),
          channel: useValueExchangeLabel(item.channel_id, interactiveChannelList),
          html_url: item.html_url
        });
      });
    },
    request: function request(params) {
      var innerParams = _extends({}, this.query, params);
      innerParams.type = Number(this.$route.params.type);
      return _getCustomList(innerParams);
    },
    handleSortChange: function handleSortChange(_ref3) {
      var column = _ref3.column,
          prop = _ref3.prop,
          order = _ref3.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    getCustomList: function getCustomList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var postdata, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.listLoading = true;
                _context.prev = 1;
                postdata = _extends({}, _this.query);

                postdata.get_total = true;
                postdata.type = Number(_this.$route.params.type);
                _context.next = 7;
                return _getCustomList(postdata);

              case 7:
                res = _context.sent;

                _this.list = _.get(res, 'data.data.list') || [];
                _this.list = _this.cookList(_this.list);
                _this.pagination.total = _.get(res, 'data.data.total') || 0;
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](1);

                _this.$message.error(_context.t0.message);

              case 16:
                _this.listLoading = false;

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 13]]);
      }))();
    },
    previewPA: function previewPA(obj) {
      this.previewDialog.visible = true;
      this.previewDialog.title = (obj.app_info || {}).name;
      this.previewDialog.html_url = obj.html_url;
      // 只有FaceBook,Unity,Vungle,Applovin,IronSource渠道需要调试Url
      if ([3, 5, 6, 7, 10].indexOf(Number(obj.type)) !== -1) {
        this.previewDialog.showDebugUrl = true;
      } else {
        this.previewDialog.showDebugUrl = false;
      }
      this.previewDialog.showCnUrl = true;
      this.previewDialog.orientation = obj.orientation;
      this.previewDialog.id = obj.id;
      this.previewDialog.setRows = function (params) {
        _Object$assign(obj, params);
      };
    }
  }
};